module.exports = __webpack_public_path__ + "static/media/dear-miss-lonelyhearts.e3498e42.jpg";